import { render, staticRenderFns } from "./EcovadisProcessor.vue?vue&type=template&id=387dbebe&scoped=true&"
import script from "./EcovadisProcessor.vue?vue&type=script&lang=js&"
export * from "./EcovadisProcessor.vue?vue&type=script&lang=js&"
import style0 from "./EcovadisProcessor.vue?vue&type=style&index=0&id=387dbebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dbebe",
  null
  
)

export default component.exports